import {CommentsCategory, useComments} from '@domain/comments'
import {useUpmPlantContext} from '@hconnect/upm'

export const useAssetCommentsQuery = (assetsIds?: number[], isDisabled = false) => {
  const {plantId} = useUpmPlantContext()

  return useComments(
    {
      plantId,
      commentsCategory: CommentsCategory.Assets,
      commentCategoryInstanceIds: assetsIds?.map(String) ?? []
    },
    'comments',
    {
      enabled: Boolean(assetsIds?.length) && !isDisabled
    }
  )
}
